import { render, staticRenderFns } from "./MyViewpoints.vue?vue&type=template&id=b003ce12&"
import script from "./MyViewpoints.vue?vue&type=script&lang=js&"
export * from "./MyViewpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports